module.exports = __webpack_public_path__ + "img/2024-12.a57c952e.jpg";